// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"18a36ca2","453":"f8575e44","667":"0fe4d7e1"}[chunkId] + ".chunk.js";
};